import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";
import DiscoverMoreButton from "../Common/DiscoverMoreButton";

const description_list = [
  {
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/earth-icon.png",
    "image_alt": "earth icon",
    "title": "For Children Tomorrow",
    "desc_desktop": "Each generation inherits the earth temporarily. The next generation shall<br />live with clean air, a nontoxic environment, and unlimited natural<br />resources as we do now.",
    "desc_mobile": "Each generation inherits the earth temporarily.<br />The next generation shall live with clean air, a<br />nontoxic environment, and unlimited natural<br />resources as we do now."
  },
  {
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/leaf-icon.png",
    "image_alt": "leaf icon",
    "title": "Consume Wisely",
    "desc_desktop": "Use baby products that are made from organic materials.<br />It will cause no harm both for the earth<br />and the baby's sensitive skin.",
    "desc_mobile": "Use baby products that are made from<br />organic materials. It will cause no harm<br />both for the earth  and the baby's sensitive<br />skin."
  },
  {
    "image": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/tree-icon.png",
    "image_alt": "tree icon",
    "title": "Environmental Change",
    "desc_desktop": "Implementing green living cause the smaller carbon footprint,<br />reduce the number of toxins released into the atmosphere,<br />and fight climate change.",
    "desc_mobile": "Implementing green living cause the smaller carbon<br />footprint, reduce the number of toxins released into<br />the atmosphere, and fight climate change."
  },
]

const esg_list = [
  {
    "esg_icon": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-3.png",
    "esg_icon_alt": "Good Health and Well Being icon",
    "esg_banner_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-3-banner-desktop.jpg",
    "esg_banner_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-3-banner-mobile.jpg",
    "title": "Good Health and Well Being",
    "desc_desktop": "Ensure healthy lives and promote well-being for all at all ages. Focuses on addressing the underlying social and economic determinants of health Including reducing maternal and child mortality.",
    "desc_mobile": "Ensure healthy lives and promote well-being for all at all ages.<br />Focuses on addressing the underlying social and economic<br />determinants of health Including reducing maternal and child mortality."
  },
  {
    "esg_icon": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-5.png",
    "esg_icon_alt": "Gender Equality icon",
    "esg_banner_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-5-banner-desktop.jpg",
    "esg_banner_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-5-banner-mobile.jpg",
    "title": "Gender Equality",
    "desc_desktop": "Achieve gender equality and empower all women and girls. Aims to ensure that women and girls have equal access to education and healthcare, and increase the number of women who are involved in decision-making processes at all levels.",
    "desc_mobile": "Achieve gender equality and empower all women and girls. Aims to ensure that women and girls have equal access to education and healthcare, and increase the number of women who are involved in decision-making processes at all levels."
  },
  {
    "esg_icon": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-9.png",
    "esg_icon_alt": "Industry, Innovation, and Infrastructure icon",
    "esg_banner_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-9-banner-desktop.jpg",
    "esg_banner_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-9-banner-mobile.jpg",
    "title": "Industry, Innovation, and Infrastructure",
    "desc_desktop": "Build resilient infrastructure, promote inclusive, and sustainable industrialization and foster innovation. Industry, innovation, and infrastructure are essential for economic growth and development.",
    "desc_mobile": "Build resilient infrastructure, promote inclusive, and sustainable industrialization and foster innovation. Industry, innovation, and infrastructure are essential for economic growth and development."
  },
  {
    "esg_icon": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-12.png",
    "esg_icon_alt": "Responsible Consumption and Production icon",
    "esg_banner_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-12-banner-desktop.jpg",
    "esg_banner_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-12-banner-mobile.jpg",
    "title": "Responsible Consumption and Production Being",
    "desc_desktop": "Ensure sustainable consumption, production patterns, and not harm the environment or human well-being. Includes reducing waste and pollution and increasing resource efficiency.",
    "desc_mobile": "Ensure sustainable consumption, production patterns, and not harm the environment or human well-being. Includes reducing waste and pollution and increasing resource efficiency."
  },
  {
    "esg_icon": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-17.png",
    "esg_icon_alt": "Partnerships for the goals. icon",
    "esg_banner_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-17-banner-desktop.jpg",
    "esg_banner_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/esg-17-banner-mobile.jpg",
    "title": "Partnerships for the goals.",
    "desc_desktop": "Collaborative efforts between different actors, including governments, private sector companies, civil society organizations, and individuals, to achieve the United Nations Sustainable Development Goals (SDGs).",
    "desc_mobile": "Collaborative efforts between different actors, including governments, private sector companies, civil society organizations, and individuals, to achieve the United Nations Sustainable Development Goals (SDGs)."
  },
]

const brand_list = [
  {
    "image_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/nero-bianco-desktop.jpg",
    "image_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/nero-bianco-mobile.jpg",
    "image_alt": "Nero Bianco",
    "link": "/brand/nero-bianco",
    "logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-nero-bianco-left.png",
    "white-logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-nero-bianco-white-middle.png",
    "desc": "Nero Bianco clothing series is made from Tencel fabric, an environmentally-friendly material created from natural eucalyptus trees. During production, Tencel requires less energy and water than conventional cotton. As a plant-derived fiber, Tencel is also biodegradable. As a material, the advantage of Tencel fiber is that it also has a soft, silky and breathable feel, a comfortable material for your little one's everyday clothes."
  },
  {
    "image_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/mooimom-desktop.jpg",
    "image_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/mooimom-mobile.jpg",
    "image_alt": "MOOIMOM",
    "link": "/brand/mooimom",
    "logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-left.png",
    "white-logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-white-middle.png",
    "desc": "By using responsible materials with sustainably harvested and production that pays attention to environmental sustainability, we are dedicated to create products that ensure the well-being of mothers and children."
  },
  {
    "image_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/mugu-desktop.jpg",
    "image_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/mugu-mobile.jpg",
    "image_alt": "mugu",
    "link": "/brand/mugu",
    "logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-left.png",
    "white-logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mugu-white-middle.png",
    "desc": "At MUGU, every product is a combination of excellent design, high-quality materials, and sustainable philosophy. By combining natural and durable ingredients, we create products to get the best experience for both children and parents. We carefully design each product with innovative technology and safety to stimulate children to learn, enjoy learning and help mothers to have better parenting life"
  },
  {
    "image_desktop": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/tweeling-desktop.jpg",
    "image_mobile": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/tweeling-mobile.jpg",
    "image_alt": "Tweeling & Co.",
    "link": "/brand/tweeling",
    "logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-tweeling-left.png",
    "white-logo": process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-tweeling-white-middle.png",
    "desc": "Using sustainable and environmentally friendly materials, Tweeling & Co is easy to use, soft, and breathable for baby's skin. Mothers also don't need to worry about shoulder injuries when using Tweeling & Co correctly."
  },
]

const AboutUs = () => {

  return (
    <>
      <div className="hidden md:block w-full relative">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/about-us-desktop.jpg"}
          alt="about us banner"
          width={2800}
          height={1152}
          quality={100}
        />
        <div className="absolute bottom-20 w-full">
          <div className="container flex justify-end">
            <h1 className="text-white text-[64px] font-dmsans font-medium -tracking-[3.2px]">
              Start Better & Greener<br />Move with Green Parenting.
            </h1>
          </div>
        </div>
      </div>
      <div className="md:hidden w-full relative">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/about/about-us-mobile.jpg"}
          alt="about us banner"
          width={1080}
          height={1667}
          quality={100}
        />
        <div className="absolute bottom-20 w-full">
          <div className="container">
            <h1 className="text-white text-[32px] font-dmsans font-medium -tracking-[1.6px]">
              Start Better &<br />Greener<br />Move with Green<br />Parenting.
            </h1>
          </div>
        </div>
      </div>
      <div className="container hidden md:flex justify-between mb-20">
        {description_list.map((desc, index) => (
          <div className="py-[54px] font-dmsans text-center"  key={index}>
            <div className="flex justify-center">
              <Image
                src={desc.image}
                alt={desc.image_alt}
                width={80}
                height={80}
                quality={100}
                className="w-[51px]"
              />
            </div>
            <p className="my-4 text-xl font-medium text-black">{desc.title}</p>
            <p className="font-normal text-black text-xs" dangerouslySetInnerHTML={{__html: desc.desc_desktop}}></p>
          </div>
        ))}
      </div>
      <div className="md:hidden">
        <Swiper
          spaceBetween={0}
          centeredSlides={true}
          loop={true}
          slidesPerView={1}
          pagination={{
            clickable: true,
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          modules={[Pagination, Navigation]}
        >
          {description_list.map((desc, index) => (
            <SwiperSlide key={index}>
              <div className="py-12 font-dmsans text-center w-full" key={index}>
                <div className="flex justify-center">
                  <Image
                    src={desc.image}
                    alt={desc.image_alt}
                    width={80}
                    height={80}
                    quality={100}
                    className="w-[51px]"
                  />
                </div>
                <p className="my-4 text-xl font-medium text-black">{desc.title}</p>
                <p
                  className="font-normal text-black text-xs"
                  dangerouslySetInnerHTML={{__html: desc.desc_mobile}}
                ></p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="hidden md:block container mb-20">
        <h2 className="text-5xl text-[#2C3E2F] text-center font-dmsans font-medium leading-tight -tracking-[2.4px] mb-12">Our ESG Topics</h2>
        <Swiper
          spaceBetween={0}
          slidesPerView={1.2}
          loop={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Pagination, Navigation]}
        >
          {esg_list.map((esg, index) =>(
            <SwiperSlide key={index}>
              <div className="flex items-center pb-8">
                <div className="relative">
                  <Image
                    src={esg.esg_banner_desktop}
                    alt={esg.title + " banner"}
                    width={600}
                    height={634}
                    quality={100}
                    className="w-[360px]"
                  />
                  <Image
                    src={esg.esg_icon}
                    alt={esg.esg_icon_alt}
                    width={200}
                    height={200}
                    quality={100}
                    className="w-[100px] absolute top-0 left-0"
                  />
                </div>
                <div className="max-w-[380px] mx-20">
                  <p className="text-[#2C3E2F] text-sm font-dmsans font-normal leading-normal -tracking-[0.7px]">{esg.title}</p>
                  <div className="border-t border-[#C6C6C6] w-[29px] border-solid my-[5px]"></div>
                  <p
                    className="text-[#2C3E2F] text-2xl font-dmsans font-normal leading-normal -tracking-[1.2px]"
                    dangerouslySetInnerHTML={{__html: esg.desc_desktop}}
                  ></p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="md:hidden mt-12">
        <h2 className="text-[32px] text-[#2C3E2F] text-center font-dmsans font-medium leading-tight -tracking-[2.4px] py-12 px-[35px]">Our ESG Topics</h2>
        {esg_list.map((esg, index) => (
          <div className={`grid grid-cols-2 gap-x-6 ${index < esg_list.length - 1 ? "mb-20" : "mb-12"}`} key={index}>
            <Image
              src={esg.esg_banner_mobile}
              alt={esg.title + " banner"}
              width={600}
              height={634}
              quality={100}
              className={`${index % 2 === 0 ? "order-1" : "order-2"}`}
            />
            <div className={`${index % 2 === 0 ? "order-2 mr-[35px]" : "order-1 ml-[35px]"}`}>
              <Image
                src={esg.esg_icon}
                alt={esg.esg_icon_alt}
                width={200}
                height={200}
                quality={100}
                className="w-[75px]"
              />
              <p
                className="text-[#2C3E2F] text-xs font-dmsans font-normal leading-normal mt-4"
                dangerouslySetInnerHTML={{__html: esg.desc_mobile}}
              ></p>
            </div>
          </div>
        ))}
      </div>
      <div className="hidden md:block container mb-[107px]">
        <h2 className="text-5xl text-[#2C3E2F] text-center font-dmsans font-medium leading-tight -tracking-[2.4px] mb-12">How Do Our Brand Support ESG?</h2>
        {brand_list.map((brand, index) => (
          <div className="grid grid-cols-2 items-center gap-x-20 mb-12" key={index}>
            <Image
              src={brand.image_desktop}
              alt={brand.image_alt + " banner"}
              width={600}
              height={474}
              quality={100}
              className={`${index % 2 === 0 ? "order-1" : "order-2"}`}
            />
            <div className={`pr-20 ${index % 2 === 1 ? "order-1" : "order-2"}`}>
              <Image
                src={brand.logo}
                alt={brand.image_alt + " logo"}
                width={245}
                height={141}
                quality={100}
              />
              <p className="my-8 text-[#2C3E2F] text-base font-dmsans font-normal leading-normal">{brand.desc}</p>
              <DiscoverMoreButton link={brand.link} />
            </div>
          </div>
        ))}
      </div>
      <div className="md:hidden container">
        <h2 className="text-[32px] text-[#2C3E2F] text-center font-dmsans font-medium leading-tight -tracking-[1.6px] mb-12">How Does Our Brand<br />Support ESG?</h2>
        {brand_list.map((brand, index) => (
          <div className={`w-full ${index < brand_list.length - 1 ? "mb-12" : "mb-[27px]"}`} key={index}>
            <div className="relative">
              <Image
                src={brand.image_mobile}
                alt={brand.image_alt + " banner"}
                width={600}
                height={272}
                quality={100}
              />
              <Image
                src={brand["white-logo"]}
                alt={brand.image_alt + " logo"}
                width={500}
                height={245}
                quality={100}
                className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[200px] max-w-full"
              />
            </div>
            <p className="mt-8 mb-4 text-[#2C3E2F] text-sm font-dmsans font-normal leading-normal">{brand.desc}</p>
            <DiscoverMoreButton link={brand.link} />
          </div>
        ))}
      </div>
    </>
  )
}

export default AboutUs
